import { createUseQuery } from 'api/common/createUseQuery'
import { fetchIntercomData } from 'api/users/fetchers/fetchIntercomData'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useIntercomData = createUseQuery({
  queryKey: ApiQueryKeys.INTERCOM_DATA,
  fetcher: fetchIntercomData,
  selector: (res?: { data?: { userHash: string } }) => res?.data?.userHash ?? null,
})
